import { queryBuilderColors } from 'vet-bones/styles/colors';
import styles from 'vet-bones/styles/colors.scss';

export const colors = {
  connected: styles['sd-cyan'],
  darkIcon: styles['sd-dark-gray-blue'],
  queryBuilderGrayId: 'sd-qb-gray',

  darkGray: styles['sd-dark-gray'],
  darkGrayBlue: styles['sd-dark-gray-blue'],
  lightGrayBlue: styles['sd-light-gray-blue'],
  darkBlue: styles['sd-dark-blue'],
  mediumBlue: styles['sd-medium-blue'],
  lightBlue: styles['sd-light-blue'],
  orange: styles['sd-orange'],
  green: styles['sd-green'],
  cyan: styles['sd-cyan'],

  softBlack: styles['sd-soft-black'],
};

export const queryBuilderColorsById = queryBuilderColors.reduce<
  Record<string, string>
>((acc, { id, color }) => {
  acc[id] = color;
  return acc;
}, {});
